import swal from "sweetalert";
import { toast } from "react-toastify";

export function showWizardValidation(t, messageKey, options) {
  swal(t("warning"), t(messageKey, options), "warning");
}

export function showWizardToast(t, messageKey, options) {
  toast.success(t(messageKey, options));
}
